import { registerMutation, registerQuery, useQuery, useMutation } from 'academy-common-lib/utils/DataFetchingClient';
import { getMockFullLiveEvent } from './liveEventMockData';
const MOCK_DELAY = 300;
const delay = data => new Promise(resolve => setTimeout(() => resolve(data), MOCK_DELAY));
const GET_FULL_LIVE_EVENT = registerQuery({
  fieldName: 'getFullLiveEvent',
  args: ['liveEventId'],
  fetcher({
    liveEventId
  }) {
    return delay(getMockFullLiveEvent(liveEventId));
  }
});
const REGISTER_FOR_SESSION = registerMutation({
  fieldName: 'registerForSession',
  args: ['sessionId'],
  fetcher({
    sessionId
  }) {
    return delay({
      id: Date.now(),
      userId: 1,
      sessionId,
      status: 'registered',
      attended: false,
      joinLink: 'https://zoom.us/j/mock-join-link',
      zoomRegistrantId: `mock-registrant-${Date.now()}`
    });
  }
});
const CANCEL_REGISTRATION = registerMutation({
  fieldName: 'cancelRegistration',
  args: ['sessionId'],
  fetcher({
    sessionId
  }) {
    return delay({
      id: Date.now(),
      userId: 1,
      sessionId,
      status: 'cancelled',
      attended: false,
      joinLink: '',
      zoomRegistrantId: ''
    });
  }
});
export const useFullLiveEvent = liveEventId => {
  var _data$assignments, _data$liveEvent, _data$sessions;
  const {
    data,
    loading,
    error
  } = useQuery(GET_FULL_LIVE_EVENT, {
    variables: {
      liveEventId
    }
  });
  return {
    assignments: (_data$assignments = data === null || data === void 0 ? void 0 : data.assignments) !== null && _data$assignments !== void 0 ? _data$assignments : [],
    error,
    liveEvent: (_data$liveEvent = data === null || data === void 0 ? void 0 : data.liveEvent) !== null && _data$liveEvent !== void 0 ? _data$liveEvent : null,
    loading,
    sessions: (_data$sessions = data === null || data === void 0 ? void 0 : data.sessions) !== null && _data$sessions !== void 0 ? _data$sessions : []
  };
};
export const useRegisterForSession = ({
  onCompleted,
  onError
} = {}) => {
  const [mutate, {
    data,
    loading,
    error
  }] = useMutation(REGISTER_FOR_SESSION, {
    onCompleted,
    onError
  });
  return {
    registerForSession: sessionId => mutate({
      variables: {
        sessionId
      }
    }),
    registrationData: data,
    registrationLoading: loading,
    registrationError: error
  };
};
export const useCancelRegistration = ({
  onError
} = {}) => {
  const [mutate, {
    data,
    loading,
    error
  }] = useMutation(CANCEL_REGISTRATION, {
    onError
  });
  return {
    cancelRegistration: sessionId => mutate({
      variables: {
        sessionId
      }
    }),
    cancellationData: data,
    cancellationLoading: loading,
    cancellationError: error
  };
};